<template>
  <div class="form-group w-100">
    <label class="d-block fs-14 text-black mb-2">{{ $t("product_page.add_multiple_images") }}</label>
    <div class="upload-gallery border-0 p-0 w-100">
      <div class="file-upload text-center position-relative mb-20 bg_ash w-100">
        <img src="../../../assets/img/icons/upload-files.svg" :alt="$t('product_page.product_image')" />
        <span class="d-block text-optional fs-14 mt-30">
          {{ $t("product_page.drag_drop_images") }}
          <span class="text_secondary fw-semibold position-relative">
            {{ $t("product_page.select") }}
          </span>
        </span>
        <input
          type="file"
          multiple
          accept="image/*"
          @change="handleFileChange"
          class="d-block w-100 shadow-none border-0 position-absolute start-0 end-0 top-0 bottom-0 z-1 opacity-0"
        />
      </div>

      <div class="d-flex flex-wrap gap-2">
        <!-- Existing Images -->
        <div v-for="(img, index) in existingImages" :key="'existing-' + index" class="position-relative" style="min-width: 60px">
          <img
            :src="img"
            :alt="$t('product_page.product_image')"
            class="rounded-1"
            style="min-width: 60px; height: auto; object-fit: contain; background: #f8f9fa;"
          />
          <button 
            type="button" 
            class="btn btn-danger btn-sm position-absolute top-0 end-0 p-0 px-1" 
            style="line-height: 1; font-size: 10px;"
            @click="$emit('remove:existing', index)"
          >×</button>
        </div>

        <!-- New Previews -->
        <div v-for="(preview, index) in previews" :key="'new-' + index" class="position-relative" style="min-width: 60px">
          <img
            :src="preview"
            :alt="$t('product_page.product_image')"
            class="rounded-1"
            style="min-width: 60px; height: auto; object-fit: contain; background: #f8f9fa;"
          />
          <button 
            type="button" 
            class="btn btn-danger btn-sm position-absolute top-0 end-0 p-0 px-1" 
            style="line-height: 1; font-size: 10px;"
            @click="removeImage(index)"
          >×</button>
        </div>
      </div>

      <!-- <div class="form-check checkbox style-two mt-40">
        <input class="form-check-input" type="checkbox" id="test_1" />
        <label class="form-check-label text-optional fs-14" for="test_1">
          Product Has Multi Variants
        </label>
      </div> -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "AddImages",
  props: {
    existingImages: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  emits: ["update:files", "remove:existing"],
  setup(props, { emit }) {
    const selectedFiles = ref<File[]>([]);
    const previews = ref<string[]>([]);

    const handleFileChange = (event: Event) => {
      const input = event.target as HTMLInputElement;
      if (input.files) {
        const files = Array.from(input.files);
        selectedFiles.value.push(...files);
        
        files.forEach(file => {
          previews.value.push(URL.createObjectURL(file));
        });
        
        emit("update:files", selectedFiles.value);
        // Clear input so same file can be selected again
        input.value = "";
      }
    };

    const removeImage = (index: number) => {
      URL.revokeObjectURL(previews.value[index]);
      selectedFiles.value.splice(index, 1);
      previews.value.splice(index, 1);
      emit("update:files", selectedFiles.value);
    };

    return {
      previews,
      handleFileChange,
      removeImage
    };
  }
});
</script>

<style lang="scss" scoped>
.upload-gallery {
  .file-upload {
    padding: 30px 20px;
    border: 1.5px dashed #a8acb2;
    text-align: center;
    border-radius: 4px;
    input {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
</style>
